import { render, staticRenderFns } from "./commentManagementList.vue?vue&type=template&id=39b0d08a"
import script from "./commentManagementList.vue?vue&type=script&lang=js"
export * from "./commentManagementList.vue?vue&type=script&lang=js"
import style0 from "./commentManagementList.vue?vue&type=style&index=0&id=39b0d08a&prod&lang=less&scope=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports